<template>
    <div>
        <md-dialog-alert
          :md-active.sync="alert"
          :md-content="msgAlert"
          md-confirm-text="Ok" />
        <div>
            <div style="height: 92px;"></div>
            <template v-for="dia in dias">
                <div>
                    <div class="event-day">{{ dia.data }}</div>
                    <div v-for="campeonato in dia.campeonatos" style="background-color: white;">
                        <div class="event-championship" style="height: 30px;line-height: 30px;" v-if="campeonato.visible">
                            {{ campeonato.pais }} - {{ campeonato.nome }}
                        </div>
                        <div v-for="evento in campeonato.eventos" class="event" v-if="campeonato.visible || evento.visible">
                            <div class="md-layout md-gutter" style="padding-bottom: 2px;padding-top: 2px;">
                                <div class="md-layout-item event-name md-size-45" v-on:click="detail(evento.id)">
                                    <div class="md-layout md-gutter" style="font-size: 1.1em !important;">
                                        <div class="md-layout-item">{{ evento.casa }}</div>
                                    </div>
                                    <div class="md-layout md-gutter"  style="font-size: 1.1em !important;">
                                        <div class="md-layout-item">{{ evento.fora }}</div>
                                    </div>
                                    <div class="md-layout md-gutter">
                                        <div class="md-layout-item event-hour">{{ formataData(dia.data) }}, {{ evento.horario }} <span style="font-weight: bold; color: #FF6600;">{{ evento.qtd }}</span></div>
                                    </div>
                                </div>
                                <div class="md-layout-item md-size-55">
                                    <div class="md-layout md-gutter event-line-odd" style="margin-bottom: 2px;">
                                        <div v-for="subevento in evento.subeventos.slice(0, 3)" class="md-layout-item md-alignment-center-center event-odd" style="font-size: 11pt;text-align: center; border-radius: 5px; height: 100%;">
                                            <table class="event-tb-odd" cellspacing="0" cellpadding="0" v-bind:class="verifyClass(subevento)" v-on:click="select(dia.data, evento, subevento)">
                                                <tr>
                                                    <td> {{ subevento.nome }} </td>
                                                </tr>
                                                <tr>
                                                    <td style="font-size: 14px;"> {{ (subevento.cotacao/100).toFixed(2) }} </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>

    import axios from 'axios'

    export default {
        name: 'TitanEvents',
        props: ['dias', 'selected', 'isLive'],
        data () {
            return {
                alert: false,
                msgAlert: ""
            }
        },
        // define métodos dentro do objeto `methods`
        methods: {
            select: function (dia, evento, subevento) {
                //console.log(subevento);
                

                if (subevento.cotacao <= 1) return false;
                if (!(this.permiteAdicionar(subevento))) {
                    this.msgAlert = "Não é permitido adicionar cotações ao vivo com cotações agendadas."
                    this.alert = true
                    return false;
                }

                subevento.evento = evento
                subevento.dia = dia

                let exists = false;
                for (let i = 0; i < this.selected.length; i++) {
                    if (this.selected[i].evento.id == evento.id) {
                        if (this.selected[i].id == subevento.id) {
                            this.selected.splice(i, 1);
                        }
                        else {
                            this.selected.splice(i, 1, subevento);
                        }
                        exists = true;
                    }
                }

                if (!exists) {
                    this.selected.push(subevento);
                }

                this.$emit('select', this.selected)
            },
            //Impede misturar cotações ao vivo com cotações agendadas
            permiteAdicionar: function(subevento) {
                for (let i = 0; i < this.selected.length; i++) {
                    if (subevento.live != this.selected[i].live) return false;
                }

                return true;
            },
            disableSubevento: function(subevento){
                return subevento.cotacao <= 1
            },
            isSelected: function(subevento) {
                let isSelected = false;
                for (let i = 0; i < this.selected.length; i++) {
                    if (this.selected[i].id == subevento.id && this.selected[i].idOpcao == subevento.idOpcao) {
                        isSelected = true;
                    }
                }

                return isSelected;
            },
            verifyClass: function(subevento) {
                return {
                    'odd-disabled': this.disableSubevento(subevento),
                    'odd-selected': this.isSelected(subevento)
                }
            },
            detail: function(event_id) {
                this.$emit('eventDetail', event_id)
                // axios
                // .get(this.$root.$data.API_URL + (this.isLive ? 'live/' : 'event/') + event_id)
                // .then(response => {
                    
          //       })
                // .finally(() => this.loadingEvents = false );
            },
            formataData: function(data) {
                if (this.isLive) return data;

                var parts = data.split(" - ");
                if (parts[1] == undefined) return data; 

                var parts2 = parts[1].split("/");
                return parts2[0] + "/" + this.traduzMes(parts2[1]);
            },
            traduzMes: function(mes) {
                switch (mes) {
                    case '01':
                        mes = 'jan';
                        break;
                    case '02':
                        mes = 'fev';
                        break;
                    case '03':
                        mes = 'mar';
                        break;
                    case '04':
                        mes = 'abr';
                        break;
                    case '05':
                        mes = 'mai';
                        break;
                    case '06':
                        mes = 'jun';
                        break;
                    case '07':
                        mes = 'jul';
                        break;
                    case '08':
                        mes = 'ago';
                        break;
                    case '09':
                        mes = 'set';
                        break;
                    case '10':
                        mes = 'out';
                        break;
                    case '11':
                        mes = 'nov';
                        break;
                    case '12':
                        mes = 'dez';
                        break;
                }
                return mes;
            }
        }
    }
</script>
<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
    primary: #000000, // The primary color of your brand
    accent: #226DA7 // The secondary color of your brand
    ));

@import "~vue-material/dist/theme/all"; // Apply the theme
</style>
